<mat-card class="components-card"
  [ngClass]="{
    'readonly-layout': isReadOnly,
    'editable-layout': !isReadOnly,
    'inherited-components-state': areComponentsInherited && !isReadOnly
  }">
  <mat-card-content>
    <!-- Non-readonly version -->
    @if (!isReadOnly) {
      @if (componentCardLabel) {
        <div class="d-flex align-items-center component-header">
          <div class="flex-fill text-center">
            <h6 class="m-0 blue-text">{{ componentCardLabel }}s ({{ components?.length || 0 }})</h6>
          </div>
          @if (showAddButton) {
            <div class="float-end button-position">
              <button mat-raised-button class="add-modifier-btn" type="button" (click)="onAddComponent()"
                [matTooltip]="'Add one or more ' + componentCardLabel?.toLowerCase() + 's for this ' + (isItem ? 'item' : isItemGrouping ? 'item group' : isModifierGrouping ? 'modifier group' : '')">
                <mat-icon>add</mat-icon>
                Add
              </button>
            </div>
          }
        </div>
      }
      @if (componentCardLabel) {
        <mat-divider class="card-divider"></mat-divider>
      }
      @if (areComponentsInherited) {
        <div class="inherited-components-message">
          <mat-icon>info</mat-icon>
          <span class="text-muted">This variation inherits the component list from the Base</span>
        </div>
      }
      <!-- Pending changes alert -->
      @if (!(isLoading$ | async) && hasPendingChanges && !hideButtons) {
        <div class="pending-changes-alert">
          <div class="alert-content">
            <mat-icon class="alert-icon">warning</mat-icon>
            <span>You have unsaved changes ({{ changesSummary }})</span>
          </div>
          <div class="alert-actions">
            <button mat-raised-button
              class="cancel-btn"
              (click)="onCancelReorder()"
              matTooltip="Discard changes">
              Cancel
            </button>
            <button mat-raised-button
              color="primary"
              class="save-btn"
              (click)="onSaveOrder()"
              matTooltip="Save changes to components">
              <mat-icon>save</mat-icon>
              Save Changes
            </button>
          </div>
        </div>
      }
      <!-- Loading State -->
      @if (isLoading$ | async) {
        <div class="d-flex justify-content-center align-items-center p-5">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      }
      <!-- Content State -->
      @if (!(isLoading$ | async)) {
        @if (componentCardLabel) {
          <div class="d-flex justify-content-center align-items-center">
            @if (components?.length > 0) {
              <div style="width: 100%;">
                <div cdkDropList
                  cdkScrollable
                  class="component-list"
                  (cdkDropListDropped)="onDrop($event)"
                  [cdkDropListDisabled]="!showAddButton"
                  [cdkDropListAutoScrollStep]="10"
                  style="max-height: 300px; overflow-y: auto;">
                  @for (component of components; track component) {
                    <div class="component-item"
                      cdkDrag
                      [cdkDragDisabled]="!showAddButton"
                      [class.moved-component]="isMovedComponent(component)"
                      [class.last-moved-component]="isLastMovedComponent(component)">
                      <div class="component-row" (click)="onViewComponent(component)">
                        @if (showAddButton) {
                          <mat-icon class="drag-handle" cdkDragHandle
                            matTooltip="Drag & drop to reorder components"
                          >drag_indicator</mat-icon>
                        }
                        <span class="component-tag"
                              [matTooltip]="getComponentTag(component)">
                            {{ getComponentTag(component) }}
                        </span>
                        @if (showAddButton) {
                          <button mat-icon-button
                            class="delete-button"
                            (click)="onDeleteComponent(component, $event)"
                            matTooltip="Delete this component">
                            <mat-icon class="delete-icon">delete</mat-icon>
                          </button>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            } @else {
              <div class="d-flex justify-content-center align-items-center">
                <p class="mt-4 text-center">{{ variation?.variationLabel || variation?.variationTag || 'This variation' }}
                has no {{ componentCardLabel?.toLowerCase() }}s</p>
              </div>
            }
          </div>
        }
      }
    }

    <!-- Readonly version -->
    @if (isReadOnly && componentCardLabel) {
      <mat-tab-group>
        <mat-tab [label]="componentCardLabel + 's  (' + (components?.length || 0) + ')'">
          <!-- Loading State -->
          @if (isLoading$ | async) {
            <div class="d-flex justify-content-center align-items-center p-5">
              <mat-spinner diameter="40"></mat-spinner>
            </div>
          }
          <!-- Content State -->
          @if (!(isLoading$ | async)) {
            <div class="d-flex justify-content-center align-items-center">
              @if (components?.length > 0) {
                <div style="width: 100%; max-height: 300px; overflow-y: auto;">
                  @for (component of components; track component) {
                    <div class="component-item">
                      <div class="component-row">
                        <span class="component-tag" [matTooltip]="getComponentTag(component)">{{ getComponentTag(component) }}</span>
                      </div>
                    </div>
                  }
                </div>
              } @else {
                <div class="d-flex justify-content-center align-items-center">
                  <p class="mt-4 text-center">{{ itemName }} has no components</p>
                </div>
              }
            </div>
          }
        </mat-tab>
      </mat-tab-group>
    }
  </mat-card-content>
</mat-card>
